module.exports = __webpack_public_path__ + "static/media/hydralogofull.27227bb8.png";